import { finderSteps, resourceTypes } from "@/mocks/guide";
import type { GuideStep, ResourceTypeItem } from "@/pages/home/types";
import SectionHeading from "@/pages/home/components/SectionHeading";

const steps = finderSteps as GuideStep[];
const types = resourceTypes as ResourceTypeItem[];

export default function GuideSection() {
  return (
    <section id="guide" className="scroll-mt-20 border-y border-background-200/70 bg-background-100/60">
      <div className="mx-auto w-full max-w-6xl px-4 py-16 md:px-6 md:py-20">
        <SectionHeading
          eyebrow="找片路径指南"
          title="五步走完，从「想看点什么」到「确定了就是它」"
          desc="很多人不是找不到资源，而是选择太多反而挑不出来。下面这套顺序能帮你把范围一点点收窄，避免在列表里来回滑动浪费时间。"
        />

        <ol className="grid grid-cols-1 gap-4 md:gap-5 sm:grid-cols-2 lg:grid-cols-5">
          {steps.map((s) => (
            <li
              key={s.id}
              className="flex flex-col gap-3 rounded-lg border border-background-200/70 bg-background-50 p-5"
            >
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-100 font-heading text-base font-semibold text-primary-700">
                {s.step}
              </span>
              <h3 className="font-heading text-base font-semibold text-foreground-950">{s.title}</h3>
              <p className="text-sm leading-relaxed text-foreground-700">{s.desc}</p>
            </li>
          ))}
        </ol>

        <div className="mt-14">
          <h3 className="font-heading text-xl font-semibold text-foreground-950 md:text-2xl">
            资源类型与获取方式说明
          </h3>
          <p className="mt-2 max-w-3xl text-sm leading-relaxed text-foreground-600">
            看片前先弄清资源类型，能少走弯路。下面三种是页面上最常出现的形态，了解区别之后再挑条目会更顺。
          </p>

          <div className="mt-6 grid grid-cols-1 gap-4 md:gap-5 lg:grid-cols-3">
            {types.map((t) => (
              <article
                key={t.id}
                className="flex flex-col gap-4 rounded-lg border border-background-200/70 bg-background-50 p-5"
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-secondary-100 text-secondary-700">
                  <i className={`${t.icon} text-xl`}></i>
                </span>
                <h4 className="font-heading text-base font-semibold text-foreground-950">{t.title}</h4>
                <p className="text-sm leading-relaxed text-foreground-700">{t.desc}</p>
                <div className="mt-auto flex flex-wrap gap-2 pt-2">
                  {t.points.map((p) => (
                    <span key={p} className="rounded-full bg-background-200/70 px-2.5 py-0.5 text-[11px] text-foreground-700">
                      {p}
                    </span>
                  ))}
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}